export const config = {
  WIDGET_URL: '/my/cloud-pbx',
  global: {
    CTA_TRANSLATIONS_ENDPOINT:
      'https://cerberus2.easybell.de/api/lokalize/project/cta',
    CTA_PRODUCT_TRANSLATIONS_ENDPOINT:
      'https://cerberus2.easybell.de/api/lokalize/project/products_markdown',
    TRANSLATIONS_API_TOKEN: '79af58581322f794c1ceb11376e6d6',
    SENTRY_DSN:
      'https://2cf01c27fdaa492781ec11481fc91d16@sentry.easybell.de/29',
  },
  AUTHENTICATON: {
    refreshTokenIntervalSeconds: 60,
    refreshWhenTokenExpiresInSeconds: 60,
    keycloak: {
      clientId: 'cta-frontend',
      realm: 'customers',
      urlEasybellDe: 'https://auth.easybell.com/',
      urlEasybellCom: 'https://auth.easybell.com/',
    },
  },
  PROVISIONING_URL: {
    production: 'https://provisioning.easybell.de/config/',
    staging: 'https://provisioning-test.easybell.de/config/',
    feature: 'https://provisioning-test.easybell.de/config/',
    local: 'https://provisioning-test.easybell.de/config/',
  },
  EKP_URL_COM: {
    feature: 'https://staging-my.dev-k8s.easybell.com',
    staging: 'https://staging-my.dev-k8s.easybell.com',
    production: 'https://my.easybell.com',
    local: 'http://localhost:4173',
  },
  EKP_URL: {
    feature: 'https://staging-my.dev-k8s.easybell.com',
    staging: 'https://staging-my.dev-k8s.easybell.com',
    production: 'https://my.easybell.com',
    local: 'http://localhost:4173',
  },
  TTC_URL: 'https://teams-trunk-frontend.easybell.de',
  BASE_URL: {
    feature: '', // USED when set otherwise automatically set
    staging: '', // NOT USED by staging environment (automatically set)
    production: 'https://ctad.k8s.easybell.de',
    // local: 'http://host.docker.internal:8004',
    // local: 'http://localhost:8004',
    local: 'https://staging-cta.dev-k8s.easybell.de',
  },
}
